module.exports = __webpack_public_path__ + "img/2.985b9e8b.png";